<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <v-card-title class="elevation-0">
          <span class="itemHeading">EMPLOYEE COMPARISON REPORT</span>
          <v-spacer></v-spacer>
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span style="font-family: kumbhRegular; font-size: 14px">
                  *Select the options to filter the results
                </span>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-0 pt-sm-0 pt-md-0>
                <v-text-field
                  v-model="keyword"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Search Employee"
                ></v-text-field>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-0 pt-sm-0 pt-md-0>
                <v-autocomplete
                  v-model="positionid"
                  :items="positionList"
                  clearable
                  item-text="name"
                  item-value="_id"
                  dense
                  hide-details
                  outlined
                  label="Choose Position"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-0 pt-sm-5 pt-md-0>
                <v-autocomplete
                  v-model="gradeFilter"
                  :items="filteredGradeList"
                  clearable
                  item-text="grade"
                  item-value="_id"
                  outlined
                  dense
                  hide-details
                  label="Choose Grade"
                ></v-autocomplete>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-xl-0 pt-lg-5 pt-sm-5 pt-md-0>
                <v-autocomplete
                  v-model="location"
                  :items="locationList"
                  clearable
                  outlined
                  dense
                  hide-details
                  label="Choose Location"
                ></v-autocomplete>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      outlined
                      hide-details
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      outlined
                      hide-details
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-text-field
                  v-model="textqualification"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Qualification"
                ></v-text-field>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-text-field
                  v-model="totalexperience"
                  outlined
                  dense
                  type="number"
                  hide-details
                  clearable
                  label="Total Experience"
                ></v-text-field>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-text-field
                  v-model="texteducation"
                  outlined
                  dense
                  hide-details
                  clearable
                  label="Education"
                ></v-text-field>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-autocomplete
                  v-model="fieldOfEducation"
                  :items="educationTypeList"
                  clearable
                  outlined
                  dense
                  hide-details
                  label="Field of Education"
                ></v-autocomplete>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5>
                <v-autocomplete
                  v-model="staffType"
                  :items="staffTypeList"
                  clearable
                  outlined
                  dense
                  hide-details
                  label="Staff Type"
                ></v-autocomplete>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5 v-if="fieldOfEducation === 'Highest Education'">
                <v-autocomplete
                  v-model="fieldOfEducationQualification"
                  :items="highestEducationList"
                  clearable
                  outlined
                  dense
                  hide-details
                  label="Highest Education"
                ></v-autocomplete>
              </v-flex>
              <v-flex xl3 lg4 md3 sm6 xs12 pr-2 pt-2 pt-lg-5 pt-sm-5 pt-md-5 v-if="fieldOfEducation === 'Additional Qualification'">
                <v-autocomplete
                  v-model="fieldOfEducationQualification"
                  :items="additionalQualificationList"
                  clearable
                  outlined
                  dense
                  hide-details
                  label="Additional Qualification"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 align-self-center text-end pt-6 v-if="data.length > 0">
                <v-btn
                  style="font-family: kumbhBold; margin-right: 8px;"
                  :outlined="isAllSelected"
                  :dark="!isAllSelected"
                  color="#005f32"
                  @click="toggleSelectAll"
                >
                  {{ isAllSelected ? 'Deselect All' : 'Select All' }}
                </v-btn>
                <v-btn
                  style="font-family: kumbhBold"
                  dark
                  color="#005f32"
                  @click="employeeExcelDownload()"
                >
                  Download Excel
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start px-4 v-if="selectedEmployees && selectedEmployees.length > 0 && !isAllSelected" style="background-color: #f9f9f9; border-radius: 8px; margin-bottom: 20px; padding: 15px; border: 1px solid #e0e0e0;">
          <v-flex xs12>
            <div class="itemHeading mb-2" style="color: #005f32; font-weight: bold;">SELECTED EMPLOYEES ({{ selectedEmployees.length }})</div>
            <v-simple-table class="align-center mb-0" style="border: 2px solid #005f32; border-radius: 8px; overflow: hidden; background-color: white;">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th style="width: 50px;"></th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Employee Id</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Name</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Designation</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Date Of Joining</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Exp With WTI</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Exp Before WTI</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Total Exp</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Monthly CTC</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Education</th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <tr v-for="item in selectedEmployees" :key="'selected-' + item._id" class="text-left align-center">
                    <td>
                      <v-checkbox
                        :input-value="true"
                        @change="deselectEmployee(item._id.toString())"
                        hide-details
                        class="mt-0"
                      ></v-checkbox>
                    </td>
                    <td style="text-align: justify">
                      <span v-if="item.employeeId" style="font-family: kumbhMedium;">{{ item.employeeId }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span v-if="item.name" style="font-family: kumbhMedium;">{{ item.name }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.positionDetails">{{ item.positionDetails[0].name }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.dateofjoining">{{ formatDate(item.dateofjoining) }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.experienceWithWTI">{{ item.experienceWithWTI }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.experienceBeforeWTI">{{ item.experienceBeforeWTI }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.totalExperienceinYears">{{ item.totalExperienceinYears }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.monthlyCTC">{{ item.monthlyCTC }}</span>
                      <span v-else>------</span>
                    </td>
                    <td>
                      <span style="font-family: kumbhMedium;" v-if="item.education">{{ item.education }}</span>
                      <span v-else>------</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>

        <v-layout wrap justify-start px-4 v-if="data.length > 0">
          <v-flex xs12 pt-3>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>
                    <th style="width: 50px;"></th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Employee Id</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Name</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Designation</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Date Of Joining</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Exp With WTI</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Exp Before WTI</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Total Exp</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Monthly CTC</th>
                    <th style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;" class="text-left">Education</th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <template>
                    <tr class="text-left align-center" style="cursor: pointer" v-for="item in data" :key="item._id + '_' + selectionKey">
                      <td>
                        <v-checkbox
                          :input-value="selectedEmployeeIds.includes(item._id.toString())"
                          @change="val => val ? selectEmployee(item) : deselectEmployee(item._id.toString())"
                          hide-details
                          class="mt-0"
                        ></v-checkbox>
                      </td>
                      <td style="text-align: justify">
                        <span v-if="item.employeeId" style="font-family: kumbhMedium; cursor: pointer">{{ item.employeeId }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span v-if="item.name" style="font-family: kumbhMedium">{{ item.name }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.positionDetails">{{ item.positionDetails[0].name }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.dateofjoining">{{ formatDate(item.dateofjoining) }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.experienceWithWTI">{{ item.experienceWithWTI }}</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.experienceBeforeWTI != null">{{ item.experienceBeforeWTI }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.totalExperienceinYears">{{ item.totalExperienceinYears }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.monthlyCTC">{{ item.monthlyCTC }}</span>
                        <span v-else>------</span>
                      </td>
                      <td>
                        <span style="font-family: kumbhMedium" v-if="item.education">{{ item.education }}</span>
                        <span v-else>------</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Data found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#005f32"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    keyword: "",
    fromDate: "",
    toDate: "",
    menu1: false,
    menu2: false,
    positionid: "",
    gradeFilter: "",
    gradeFilterList: [],
    positionList: [],
    filters: {
      salary: false,
      qualification: false,
      PreExp: false,
      totalExp: false,
      monthlyCTC: false,
      education: false,
      disciplinaryAction: false,
      salaryComparison: false,
      pancard: false,
      pmr: false,
      grade: false,
      bankdetails: false,
      adhar: false,
    },
    showsnackbar: false,
    ServerError: false,
    msg: null,
    appLoading: false,
    g: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    data: [],
    pages: 0,
    currentPage: 1,
    totalData: 0,
    locationList: [
    ],
    location: "",
    staffType: "",
    staffTypeList: ["HQ", "Field"],
    totalexperience: "",
    texteducation: "",
    textqualification: "",
    fieldOfEducation: "",
    fieldOfEducationQualification: "",
    educationTypeList: [
      "Highest Education",
      "Additional Qualification"
    ],
    highestEducationList: [
      "Bachelors",
      "Masters",
      "PhD"
    ],
    additionalQualificationList: [
      "1-year Diploma",
      "2-year Diploma"
    ],
    selectedEmployeeIds: [],
    selectedEmployees: [],
    selectionKey: 0,
  }),
  computed: {
    isAllSelected() {
      if (!this.data || this.data.length === 0 || this.totalData === 0) {
        return false;
      }
      return this.selectedEmployeeIds.length === this.totalData;
    },
    sortedData() {
      return this.data;
    },
    filteredGradeList() {
      return this.gradeFilterList.filter(
        (item, index) => index !== 0 && item._id !== null
      );
    },
  },
  mounted() {
    this.getData();
    if (this.position === "62a2de91ecd959516cd3b0e6") {
      this.getData();
    }
    this.getPositions();
    this.getGrades();
    this.getLocations();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    totalexperience() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    texteducation() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    textqualification() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    keyword() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    positionid() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    gradeFilter() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    location() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    fromDate() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    toDate() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    staffType() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    fieldOfEducation() {
      this.fieldOfEducationQualification = "";
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
    fieldOfEducationQualification() {
      if (this.currentPage === 1) this.getData();
      else this.currentPage = 1;
    },
  },
  methods: {
    getLocations() {
      axios({
        url: "/organisation/locations/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.locationList = response.data.data.map((item) => item.name);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGrades() {
      this.appLoading = true;
      axios({
        url: "/grade/dropdown/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.gradeFilterList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getPositions() {
      this.appLoading = true;
      axios({
        url: "/getalllist/position/v1",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.positionList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/report/employee/details/salaryComparison/list",
        method: "GET",
        params: {
          keyword: this.keyword,
          fromDate: this.fromDate,
          toDate: this.toDate,
          positionid: this.positionid,
          gradeFilter: this.gradeFilter,
          locationText: this.location,
          totalExpText: this.totalexperience,
          educationText: this.texteducation,
          qualificationText: this.textqualification,
          fieldOfEducationCategory: this.fieldOfEducation,
          fieldOfEducation: this.fieldOfEducationQualification,
          salaryComparison: true,
          staffType: this.staffType,
          page: this.currentPage,
          limit: 20,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.data = response.data.employees;
          this.totalData = response.data.total;
          this.pages = Math.ceil(this.totalData / response.data.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(date) {
      if (!date) return '';
      const dt = new Date(date);
      const day = String(dt.getDate()).padStart(2, '0');
      const month = String(dt.getMonth() + 1).padStart(2, '0');
      const year = dt.getFullYear();
      return `${day}-${month}-${year}`;
    },
    async toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedEmployeeIds = [];
        this.selectedEmployees = [];
        this.selectionKey++;
        return;
      }
      try {
        this.appLoading = true;
        const response = await axios({
          url: "/report/employee/details/salaryComparison/list",
          method: "GET",
          params: {
            keyword: this.keyword,
            fromDate: this.fromDate,
            toDate: this.toDate,
            positionid: this.positionid,
            gradeFilter: this.gradeFilter,
            locationText: this.location,
            totalExpText: this.totalexperience,
            educationText: this.texteducation,
            qualificationText: this.textqualification,
            fieldOfEducationCategory: this.fieldOfEducation,
            fieldOfEducation: this.fieldOfEducationQualification,
            salaryComparison: true,
            staffType: this.staffType,
            getAllIds: true,
          },
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        });
        this.appLoading = false;
        if (response.data.status || response.data.allIds) {
          this.selectedEmployeeIds = response.data.allIds.map(id => id.toString());
          this.selectedEmployees = [];
          this.selectionKey++;
        }
      } catch (err) {
        this.appLoading = false;
        console.log(err);
      }
    },
    selectEmployee(item) {
      const id = item._id.toString();
      if (!this.selectedEmployeeIds.includes(id)) {
        this.selectedEmployeeIds = [...this.selectedEmployeeIds, id];
        this.selectedEmployees = [...this.selectedEmployees, item];
      }
    },
    deselectEmployee(id) {
      this.selectedEmployeeIds = this.selectedEmployeeIds.filter(x => x !== id);
      this.selectedEmployees = this.selectedEmployees.filter(e => e._id.toString() !== id);
    },
    employeeExcelDownload() {
      axios({
        method: "GET",
        url: "/report/employee/details/salaryComparison/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.keyword,
          fromDate: this.fromDate,
          toDate: this.toDate,
          positionid: this.positionid,
          gradeFilter: this.gradeFilter,
          locationText: this.location,
          totalExpText: this.totalexperience,
          educationText: this.texteducation,
          qualificationText: this.textqualification,
          fieldOfEducation: this.fieldOfEducation,
          fieldOfEducationQualification: this.fieldOfEducationQualification,
          salaryComparison: true,
          staffType: this.staffType,
          selectedEmployeeIds: this.selectedEmployeeIds,
        },
        responseType: "blob",
      })
        .then((response) => {
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.target = "_blank";
          anchor.download = "Salary Comparison Report.xlsx";
          anchor.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.tableHead {
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhMedium;
}
</style>